
export enum NavigationMenu {
    SmartPower = 'smartpower',
    TotalValueDelivery = 'total-value-delivery',
    SolutionParticipationDetails = 'solution-participation-details',
    ServiceInsights = 'service-insights',
    CustomerOverview = 'customer-overview',
    ActionCenter = 'action-center'
}
